import React, { Component } from 'react';
import { toast, ToastContainer, MDBCardText, MDBCard, MDBCardTitle, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBInputGroup, MDBContainer, MDBBadge } from 'mdbreact';
import Header from './ComponentFragments/Header';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Colors from '../Styles/Colors';
import TopSeller from './ComponentFragments/TopSeller';
import SelectSearch from 'react-select-search';
import ReactToPrint from 'react-to-print';
import { template } from 'lodash';


class InvoiceOrder extends Component {
    constructor(props) {
        super(props);
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        this.state = {
            cartData: {
                cartItems: []
            },
            documentHeader: [],
            documentType: '',
            documentNo: '',
            onOrAfter: false 
        }
        this.formatter = new Formatter();
        this.dl = new DataLayer();

        
    }

    async componentWillMount() {
        let params = this.props.location.search //?id=24538210&released=true
        if (this.props.location.state.documentType == 'PaymentAdvice') {
            let response = await this.dl.Get("/demonstrator/GetInvoiceOrderIdFromMerchantRef" + params)
            params = "?id=" + response.data.id + "&released=" + response.data.released;
            let documentType = '';
            let documentNo = response.data.id;
            documentType = response.data.released ? "INVOICE" : "ORDER";
            this.getInvoiceOrderData(params, documentType, documentNo);
        } else {
            
            this.getInvoiceOrderData(params, this.props.location.state.documentType, this.props.location.state.documentNo);
        }

        
    }

    async getInvoiceOrderData(params, documentType, documentNo) {
        let response = await this.dl.Get("/common/getinvoiceorder" + params);
        let headerResponse = await this.dl.Get("/common/getdocumentheader" + params)
        console.log('Header Data', headerResponse)
        var tDate = new Date(headerResponse.data.transactionDate);
        const cutoffDate = new Date('2026-01-01');
        console.log('tDate', tDate)
        const isOnOrAfter = tDate >= cutoffDate;
        var tempCartData = response.data;
        //if (this.TMAUser.data.countryId == 6) {
        //    tempCartData.deliveryCharge = response.data.fixedCharge;
        //    tempCartData.fixedCharge = 0;

        //}
        this.setState({
            cartData: response.data,
            documentHeader: headerResponse.data,
            documentType: documentType,
            documentNo: documentNo,
            onOrAfter: isOnOrAfter
        })

        this.props.loaderOff()
    }

    renderGhana() {
        

        if (this.state.onOrAfter) {
            let GETFund = (((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)) * (2.5 / 100);
            let NHIS = (((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)) * (2.5 / 100);
            let subtotal = (this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue;

            GETFund = Math.round((GETFund + Number.EPSILON) * 100) / 100;
            NHIS = Math.round((NHIS + Number.EPSILON) * 100) / 100;
            subtotal = Math.round((subtotal + Number.EPSILON) * 100) / 100;

            //subtotal += nhil + gfl + chrl
            let ghanaTax = subtotal * (this.state.documentHeader.taxRate / 100);
            let ghanaInvoiceTotal = subtotal + ghanaTax + GETFund + NHIS;
            return (
                <MDBRow className="mx-1">
                    <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                        <div className="cartSummaryItem"> </div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)}</div>
                    </MDBCol>



                    <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                        <div className="cartSummaryItem">GET Fund:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(GETFund)}</div>
                    </MDBCol>

                    <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                        <div className="cartSummaryItem">NHIS:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(NHIS)}</div>
                    </MDBCol>

                    <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                        <div className="cartSummaryItem">Tax:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(ghanaTax)}</div>
                    </MDBCol>
                    <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                        <div className="cartSummaryItem">{this.state.documentType} Total:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(ghanaInvoiceTotal)}</div>
                    </MDBCol>
                </MDBRow>
                )
        } else {
            let nhil = (((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)) * (2.5 / 100)
            let gfl = (((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)) * (2.5 / 100)
            let chrl = (((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)) * (1 / 100);

            let subtotal = (this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue;
            subtotal += nhil + gfl + chrl
            let ghanaTax = subtotal * (this.state.documentHeader.taxRate / 100);
            let ghanaInvoiceTotal = subtotal + ghanaTax;
            return (
                

                <MDBRow className="mx-1">
                    <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                        <div className="cartSummaryItem"> </div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)}</div>
                    </MDBCol> 
                                        

        
            <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                <div className="cartSummaryItem">NHIL:</div>
                <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(nhil)}</div>
            </MDBCol> 
        
            <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                <div className="cartSummaryItem">GFL:</div>
                <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(gfl)}</div>
            </MDBCol> 
        
            <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                <div className="cartSummaryItem">CHRL:</div>
                <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(chrl)}</div>
            </MDBCol> 
        
            <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                <div className="cartSummaryItem">Sub Total:</div>
                <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(subtotal)}</div>
            </MDBCol> 
        
            <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                <div className="cartSummaryItem">Tax:</div>
                <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(ghanaTax)}</div>
                    </MDBCol>
                    <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                        <div className="cartSummaryItem">{this.state.documentType} Total:</div>
                        <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(ghanaInvoiceTotal)}</div>
                    </MDBCol>
                    </MDBRow>
                )
        }
    }

    render() {
        let docType = this.state.documentType;
        let countryId = this.state.documentHeader.countryId;

        //let nhil = (((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)) * (2.5 / 100)
        //let gfl =    (((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)) * (2.5 / 100)
        //let chrl = (((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)) * (1 / 100);

        let GETFund = (((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)) * (2.5 / 100);
        let NHIS = (((this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue)) * (2.5 / 100);
        let subtotal = (this.state.cartData.subTotal + this.state.cartData.rounding) - this.state.cartData.discountValue;
        //subtotal += nhil + gfl + chrl
        let ghanaTax = subtotal * (this.state.documentHeader.taxRate / 100);
        let ghanaInvoiceTotal = subtotal + ghanaTax + GETFund + NHIS;
        return (
            <div>
                <MDBRow>
                    <MDBCol className="text-right">
                    <ReactToPrint
                        trigger={() => <MDBBtn rounded color="purple" size="sm">Print</MDBBtn>}
                        content={() => this.componentRef}
                        />
                        </MDBCol>
                </MDBRow>
                <div ref={el => (this.componentRef = el)}>

                    <MDBCard className="card-body">
                        
                        <MDBCardText>
                            <MDBRow className="mx-2">
                                <MDBCol sm="12">
                                <span>{this.state.documentType} NO:&nbsp;
                                        <span style={{ color: Colors.plum, fontWeight: "Bold" }}>{this.state.documentNo}</span></span><br /><br />
                            </MDBCol>
                                    </MDBRow>
                            <MDBRow className="mx-2">
                                <MDBCol md="6" sm="12">
                                    From: <br />
                                    <strong>{this.state.documentHeader.tradingName}</strong> <br />
                                    <span style={{ fontSize: "14px" }}>
                                        AUTHORISED DISTRIBUTORS OF TUPPERWARE PRODUCTS<br />
                                        {this.state.documentHeader.addressLine1}<br />
                                        {this.state.documentHeader.addressLine2}<br />
                                        {this.state.documentHeader.addressLine3}<br />
                                        TEL:&nbsp;{this.state.documentHeader.telephone}<br />
                                        VENDOR NO:&nbsp;{this.state.documentHeader.vendorNumber}<br />
                                        Discount Level: {this.state.documentHeader.levelName}
                                    </span>
                                </MDBCol>
                                <MDBCol md="6" sm="12">
                                    To:<br />
                                    <strong>{this.state.documentHeader.demName}</strong><br />
                                    <span style={{ fontSize: "14px" }}>
                                        {this.state.documentHeader.dAddressLine1}<br />
                                        {this.state.documentHeader.dAddressLine2}<br />
                                        {this.state.documentHeader.dAddressLine3}<br />
                                        {this.state.documentHeader.dPostalCode}<br />
                                        DEM CODE:&nbsp;{this.state.documentHeader.sfCurrentCode}<br />
                                        Transaction Date:&nbsp;<strong>{this.state.documentHeader.transactionDate}</strong><br />
                                        {/*{this.state.documentHeader.levelPercentage == -1 ? <div>test</div> : <div>Discount Percentage: {this.state.documentHeader.levelPercentage}</div>}*/}
                                    </span>
                                </MDBCol>
                            </MDBRow>
                        </MDBCardText>
                    </MDBCard>

                    <MDBRow>
                        <MDBCol xl="8" lg="7" md="12">
                            <MDBCard className="card-body" style={{ marginTop: "1rem" }}>

                                {
                                    this.state.cartData.cartItems.map((item, index) => {
                                        return (
                                            <div key={index}>
                                                <MDBRow className="mx-2" between>
                                                    {/*<MDBCol>
                                                    <img src="https://mdbootstrap.com/img/Others/documentation/1.jpg" className="img-fluid" alt="" />
                                                </MDBCol>*/}
                                                    <MDBCol >
                                                        <span style={{ color: Colors.purple, fontWeight: "bold" }}>{item.processingCode}:&nbsp;{item.invoiceDescription}</span><br />
                                                        <MDBRow>
                                                            <MDBCol>
                                                                <span style={{ fontSize: "14px" }}>Retail: {this.formatter.formatCurrency(item.retail)}</span>
                                                            </MDBCol>
                                                            <MDBCol>
                                                                <span style={{ fontSize: "14px" }}>Price: {this.formatter.formatCurrency(item.price)}</span><br />
                                                            </MDBCol>
                                                            <MDBCol>
                                                                <span style={{ fontSize: "14px" }}>Qty:&nbsp;{item.qty}</span>
                                                                
                                                            </MDBCol>
                                                            <MDBCol>
                                                                <span style={{ fontSize: "14px", fontWeight: "bold" }}>Total: {this.formatter.formatCurrency((item.price * item.qty))}</span>
                                                            </MDBCol>
                                                        </MDBRow>

                                                    </MDBCol>

                                                </MDBRow><hr className="hr_grey" />

                                            </div>
                                        );
                                    })
                                }
                            </MDBCard>
                        </MDBCol>
                        <MDBCol>
                            <MDBCard className="card-body" style={{ marginTop: "1rem", color: this.state.dirty ? "#bdbdbf" : Colors.black }}>
                                <MDBCardTitle className="mx-2" style={{ fontSize: "16px", paddingBottom: "3px" }}><MDBIcon icon="file-signature" />&nbsp;{docType} Summary</MDBCardTitle>
                                <MDBCardText>
                                    <MDBRow className="mx-1">
                                        <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                                            <div className="cartSummaryItem">Items Total:</div>
                                            <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.itemsTotal)}</div>
                                        </MDBCol>
                                        <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                                            <div className="cartSummaryItem">Delivery Charge:</div>
                                            <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.deliveryCharge)}</div>
                                        </MDBCol>
                                        <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                                            <div className="cartSummaryItem"> Fixed Charge:</div>
                                            <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.fixedCharge)}</div>
                                        </MDBCol>
                                        <MDBCol sm="12">
                                            <hr className="hr_grey" />
                                        </MDBCol>
                                        {countryId == 11 ? <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                                            <div className="cartSummaryItem">Total Excl.:</div>
                                            <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.subTotal)}</div>
                                        </MDBCol> :
                                            <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                                                <div className="cartSummaryItem">Sub Total:</div>
                                                <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.subTotal)}</div>
                                            </MDBCol>
                                        }
                                        {countryId != 11 ? <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                                            <div className="cartSummaryItem">VAT:</div>
                                            <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.vat)}</div>
                                        </MDBCol>:<div></div>}
                                        
                                        <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                                            <div className="cartSummaryItem">Rounding:</div>
                                            <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.rounding)}</div>
                                        </MDBCol>
                                        <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                                            <div className="cartSummaryItem">Discount:</div>
                                            <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.discountValue)}</div>
                                        </MDBCol>

                                        {countryId == 11 ? this.renderGhana() : <div></div>}

                                        <MDBCol sm="12">
                                            <hr className="hr_grey" />
                                        </MDBCol>
                                        {countryId == 11 ? <div></div> :
                                        <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                                            <div className="cartSummaryItem">{this.state.documentType} Total:</div>
                                            <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.orderTotal)}</div>
                                        </MDBCol>
                                        }


                                        <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                                            <div className="cartSummaryItem">Recognition Total:</div>
                                            <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.recognitionTotal)}</div>
                                        </MDBCol>
                                        <MDBCol sm="12">
                                            <hr className="hr_grey" />
                                        </MDBCol>

                                        <MDBCol sm="12">
                                            <div style={{ fontSize: "12px" }}>
                                                <span style={{ fontWeight: "bold" }}>{this.state.documentHeader.comments}</span><br /><br />
                                                
                                            </div>
                                        </MDBCol>

                                        <MDBCol sm="12">
                                            <div style={{ fontSize: "12px" }}>
                                                <span style={{fontWeight: "bold"}}>{this.state.documentHeader.message}</span><br /><br />
                                                DISPATCH TYPE:&nbsp;{this.state.documentHeader.dispatchType}<br />
                                                DISPATCH AREA:&nbsp;{this.state.documentHeader.dispatchArea}<br />
                                                WAREHOUSE:&nbsp;{this.state.documentHeader.warehouse}<br /><br />
                                                {this.state.documentHeader.standardInvoiceMessage}
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBCardText>
                            </MDBCard>
                        </MDBCol>
                    </MDBRow>
                    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={5000}
                    />
                </div>
            </div>
        )
    }
}

export default InvoiceOrder;